import React from 'react';

export default function Icon({ name, className = '', color = 'currentColor', ...props }) {
    if (!name) {
        console.warn('Icon name is required');
        return null;
    }

    // SVG içindeki <symbol> veya <svg> ID'si doğrudan name ile eşleşmeli
    const href = `#${name}`;

    return (
        <svg
            className={`icon ${className}`}
            style={{ color }}
            {...props}
        >
            <use href={href} />
        </svg>
    );
}